import { useSelector } from 'react-redux';
import { selectBrand, selectBranch } from './selectors';

export const useBrand = () => useSelector(selectBrand());
export const useBranch = () => useSelector(selectBranch());
